import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { beginSurveyLink, getIdentityFirstLogin } from 'store/entities/identity/selectors'
import { requestSurvey } from 'store/entities/identity/actions'
import { setRun } from 'store/entities/tour/actions'
import OnBoardingBriefQuiz from './OnBoardingBriefQuiz'
import { showTypeFormPopup } from 'store/entities/typeform/actions'
import { modal } from 'store/entities/modal/actions'
import { getQueries } from 'store/entities/localSettings/selectors'

const mapStateToProps = createStructuredSelector({
  beginSurveyLink,
  isFirstLogin: getIdentityFirstLogin,
  queries: getQueries,
})

const mapDispatchToProps = {
  requestSurvey: sendEmail => requestSurvey({ surveyType: 'begin', sendEmail }),
  showTypeFormPopup,
  hideModal: modal.hide,
  setRun,
}

const mergeProps = (
  { beginSurveyLink, ...restState },
  { showTypeFormPopup, requestSurvey, hideModal, ...restDispatch },
  ownProps
) => ({
  ...restState,
  ...ownProps,
  ...restDispatch,
  requestSurvey,
  hideModal,
  showTypeFormPopup: () =>
    showTypeFormPopup({
      typeFormLink: beginSurveyLink,
      onSubmit: () => {
        requestSurvey(false)
        hideModal()
      },
    }),
  beginSurveyLink,
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(OnBoardingBriefQuiz)
